import type { DealCard } from '../../../utils/buildDealCards/dealCardTypes';
import { formatPrice } from '../../../utils/formatting';
import type { Localization } from '../../../common/Localization';

export const getDynamicDepositAmount = (
  dealCard: DealCard,
  localization: Localization
): { pp: string; total: string } => {
  const price = dealCard?.product?.rate?.price?.depositAmount;
  const totalPrice = dealCard?.product?.rate?.price?.total.depositAmount;
  return {
    pp: formatPrice({ price, localization }),
    total: formatPrice({ price: totalPrice, localization }),
  };
};
